<template>
  <v-card class="base-card shadow">
    <v-card-title>
      <strong>Работа в журналах</strong>
    </v-card-title>

    <v-card-text
      class="pb-6 d-flex flex-column"
      style="gap: 32px"
    >
      <div
        class="d-flex flex-column"
        style="gap: 32px"
        v-if="journals.length"
      >
        <div
          v-for="(item, index) in journals"
          :key="index"
        >
          <div>
            <h3>№ {{ index + 1 }}</h3>

            <SimpleTextRow
              class="mt-2"
              name="Издание"
              v-model="item.magazineName"
              hide-border-bottom
            />
            <SimpleTextRow
              name="Роль"
              v-model="item.editorialBoardRoleName"
              :hide-border-bottom="index + 1 === journals.length"
            />
          </div>
        </div>
      </div>
      <div
        v-else
        class="text-center"
      >
        У вас нет работ в журналах или их нужно актуализировать
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { cloneDeep } from 'lodash'
import { Employee } from '../../models'
import SimpleTextRow from '../ui/SimpleTextRow'
import { journalEditorialBoardApi } from '../../api'

export default {
  name: 'EditorialBoardCard',

  props: {
    selectedEmployee: Object
  },

  components: {
    SimpleTextRow
  },

  data: () => {
    return {
      employee: new Employee(),
      journals: []
    }
  },

  methods: {
    async getEditorialBoardData() {
      try {
        this.journals = await journalEditorialBoardApi.findActualByEmployeeId(this.employee.id)
      } catch (e) {
        console.error(e)
      }
    }
  },

  watch: {
    selectedEmployee: {
      deep: true,
      immediate: true,
      handler(val) {
        this.employee = cloneDeep(val)
        if (this.employee?.id) {
          this.getEditorialBoardData()
        }
      }
    }
  }
}
</script>

<style scoped></style>
